import React, { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import { Card, Col, Row } from 'react-bootstrap';
import { Link, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import PDCConvert from '../PumpDC/SoToDcConvert';
import { authHeader } from '../../../services/auth-header';
import { BASE_URL } from '../../../services/Api';
import MDConvert from '../ManufacturingDC/Convert';

function SoToDcConert() {
    const navigate = useNavigate();
    const { pointindex, id } = useParams();
    const [salesordertype, setsalesordertype] = useState();
    const [salesordercategory, setsalesordercategory] = useState();
    const [enquiryData, setenquiryData] = useState();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${BASE_URL}salesOrder/findById/${id}`, {
                    headers: authHeader(),
                });
                console.log(' id api', response.data);
                setenquiryData(response.data);
                setsalesordertype(response.data.salesordertype);
                setsalesordercategory(response.data.salesordercategory);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchData();
    }, [id]);
    console.log('aa ', enquiryData);

    const renderPageDisplay = () => {
        if (salesordertype === 'Pump Spare') {
            if (salesordercategory === 'Domestic') {
                return <PDCConvert enquiryData={enquiryData} />;
            }
        } else if (salesordertype === 'Manufacturing') {
            if (salesordercategory === 'Domestic') {
                return <MDConvert enquiryData={enquiryData} />;
            }
        }
        return null; // Default case
    };

    const handleDelete = async (id) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
        });

        if (result.isConfirmed) {
            try {
                const response = await axios.delete(`${BASE_URL}deliveryChallan/delete/${id}`, {
                    headers: authHeader(),
                });
                if (response.data.length === 0) {
                    Swal.fire('Warning', 'PO is present in another module. Delete operation has been cancelled.', 'warning');
                } else {
                    navigate(`/poindex/${pointindex}`);
                    Swal.fire('Deleted!', 'Deleted successfully.', 'success');
                }
            } catch (error) {
                Swal.fire('Error', error.response?.data || 'An error occurred', 'error');
            }
        }
    };

    return (
        <div className="Container">
            <Card className="card">
                <Card.Header className="card-header">
                    <h6>CONVERT SALES ORDER TO DELIVERY CHALLAN</h6>
                    <div className="view-buttons">
                        {/* <button className="button-70" onClick={() => handleDelete(id)}>DELETE</button> */}
                        {/* <Link to={`/dcEdit/${id}/${pointindex}`}>
              <button className="button-70">EDIT</button>
            </Link> */}
                        <Link to={`/salesOrderIndexTable/1`}>
                            <button className="button-70">BACK</button>
                        </Link>
                    </div>
                </Card.Header>
                <Card.Body>
                    <Row>
                        <Col md="6">
                            <Form.Group>
                                <Form.Label>Select a Product Type:</Form.Label>
                                <Form.Select disabled value={salesordertype} onChange={(e) => setsalesordertype(e.target.value)}>
                                    <option value="">--Please choose an option--</option>
                                    <option value="Pump Spare">Pump Spare</option>
                                    <option value="Manufacturing">Manufacturing</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col md="6">
                            <Form.Group>
                                <Form.Label>Select a DC Category:</Form.Label>
                                <Form.Select disabled value={salesordercategory} onChange={(e) => setsalesordercategory(e.target.value)}>
                                    <option value="">--Please choose an option--</option>
                                    <option value="Domestic">Domestic</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        {renderPageDisplay()}
                    </Row>
                </Card.Body>
            </Card>
        </div>
    );
}

export default SoToDcConert;
